import React, { useState, useEffect } from 'react';
import './ShrimpRoll.css';
import rollCangrejoTempuraImage from '../assets/Tipos de Rolls/ROLL Camaron - Cangrejo Tempura.png';

const ShrimpRoll = () => {
  const [activeDotIndex, setActiveDotIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const ingredientDots = [
    { style: { top: '14%', left: '40%' }, label: 'ARROZ' },
    { style: { top: '40%', right: '25%' }, label: 'CAMARÓN' },
    { style: { bottom: '4%', left: '50%' }, label: 'ALGA NORI TEMPURA' },
    { style: { bottom: '18%', left: '35%' }, label: 'CEBOLLIN' },
    { style: { bottom: '20%', left: '20%' }, label: 'QUESO CREMA' },
    { style: { top: '40%', left: '18%' }, label: 'CANGREJO' },
  ];

  useEffect(() => {
    if (isHovered || ingredientDots.length === 0) {
      // Stop animation and clear any active dot when user is interacting
      setActiveDotIndex(null);
      return;
    }

    // Automatic cycling through dots when not hovered
    const intervalId = setInterval(() => {
      setActiveDotIndex((prev) => {
        if (prev == null) return 0;
        const next = (prev + 1) % ingredientDots.length;
        return next;
      });
    }, 1500);

    return () => clearInterval(intervalId);
  }, [isHovered, ingredientDots.length]);

  return (
    <section className="shrimp-roll">
      <div className="container">
        <div className="shrimp-roll-header">
          <h2 className="section-title">ROLL CAMARÓN</h2>
          <p className="section-subtitle">
            Toca cada punto rojo y descubre los ingredientes de tu roll favorito.
          </p>
        </div>
        <div
          className="shrimp-roll-content"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="shrimp-roll-image-container">
            <img 
              src={rollCangrejoTempuraImage} 
              alt="Shrimp Roll"
              className="shrimp-roll-image"
            />
            <div className="ingredient-dots">
              {ingredientDots.map((dot, index) => (
                <div
                  key={dot.label}
                  className={`ingredient-dot${activeDotIndex === index ? ' active' : ''}`}
                  style={dot.style}
                >
                  <span className="dot-marker"></span>
                  <span className="dot-label">{dot.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShrimpRoll;

